import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import { format } from 'date-fns'
import { Task } from 'gantt-task-react'
import { Task as ITask } from 'utils/__generated__/graphql'

type TaskListTableProps = {
  rowHeight: number
  rowWidth: string
  fontFamily: string
  fontSize: string
  locale: string
  tasks: ITask[]
  selectedTaskId: string
  setSelectedTask: (task: Task) => void
}

function TaskListTable({
  rowHeight,
  fontFamily,
  fontSize,
  tasks,
  selectedTaskId,
  rowWidth,
  setSelectedTask,
}: TaskListTableProps) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        fontFamily,
        fontSize,
        borderRight: `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <Table
        size="small"
        sx={{
          '& .MuiTableCell-root': {
            borderLeft: `1px solid ${theme.palette.grey[300]}`,
            p: '0 8px',
          },
        }}
      >
        <TableBody>
          {tasks.map(task => (
            <TableRow
              key={task.id}
              hover
              onClick={() => setSelectedTask(task as Task)}
              sx={{
                height: rowHeight,
                backgroundColor:
                  task?.id?.toString() === selectedTaskId
                    ? '#e0f7fa'
                    : 'inherit',
                cursor: 'pointer',
              }}
            >
              <TableCell
                sx={{
                  minWidth: rowWidth,
                  maxWidth: rowWidth,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <Tooltip title={task.name} arrow>
                  <span>{task.name}</span>
                </Tooltip>
              </TableCell>
              <TableCell
                sx={{
                  minWidth: rowWidth,
                  maxWidth: rowWidth,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <Typography variant="body2" noWrap>
                  {task.assignee}
                </Typography>
              </TableCell>
              <TableCell sx={{ minWidth: rowWidth, maxWidth: rowWidth }}>
                {format(new Date(task.start), 'MM/dd/yyyy')}
              </TableCell>
              <TableCell
                sx={{
                  minWidth: rowWidth,
                  maxWidth: rowWidth,
                  whiteSpace: 'nowrap',
                }}
              >
                {format(new Date(task.end), 'MM/dd/yyyy')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default TaskListTable
